<!-- 订单查询 -->
<template>
<div class="page-form">
    <PageBack :title="title" />
    <div class="detail-wrap">
        <el-tabs v-model="activeName" type="card" @tab-click="handleSwitchTab">
            <el-tab-pane 
                v-for="item in orderType"
                :key="item.label"
                :label="item.label" 
                :name="item.value">           
            </el-tab-pane>
        </el-tabs>  
        <el-form :model="searchForm" ref="searchForm"  :inline="true"> 
            <el-form-item label="姓名" prop="username">
                <el-input style="width: 200px;" v-model="searchForm.username"></el-input>
            </el-form-item>   
            <el-form-item label="手机号" prop="phone">
                <el-input style="width: 200px;" v-model="searchForm.phone"></el-input>
            </el-form-item>            
            <el-form-item label="订单号" prop="orderId">
                <el-input style="width: 200px;" v-model="searchForm.orderId"></el-input>
            </el-form-item> 
            <el-form-item label="商品标题" prop="title">
                <el-input style="width: 200px;" v-model="searchForm.title"></el-input>
            </el-form-item> 
            <el-form-item label="分类" prop="certType">
                <el-select v-model="searchForm.certType" style="width: 100%;">
                    <el-option 
                        v-for="item in typeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>                   
            <el-form-item label="状态" prop="status">
                <el-select v-model="searchForm.status" style="width: 100%;">
                    <el-option 
                        v-for="item in statusOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>
                <el-button @click="resetForm('searchForm')">重置</el-button>
            </el-form-item>          
        </el-form>
        <el-table border :data="tableData" style="width: 100%;">
            <el-table-column  prop="index"   label="序号"   width="50" align="center"/>     
            <el-table-column  prop="username"  label="下单人" width="120"  align="center"/>  
            <el-table-column  prop="tel"  label="联系电话" width="120"  align="center"/>
            <el-table-column  prop="productName"   label="商品" width="140" align="center"/>              
            <el-table-column  prop="price"   label="价格" width="100" align="center"/>
            <el-table-column  prop="quanlity"   label="数量" width="90" align="center"/> 
            <el-table-column  prop="address"   label="收货地址" align="center">
                <template slot-scope="scope">                   
                    <div @click="lookAddress(scope.row)" class="address">{{scope.row.province }}{{scope.row.city  }}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="dateFormat"  label="下单日期" width="160"  align="center" />
            <el-table-column  prop="status"  label="状态" align="center"  width="140"/>
            <el-table-column  fixed="right" label="操作">
                <template slot-scope="scope">   
                    <el-button @click="handleDelivery(scope.row)" type="text" 
                    size="small" v-if="scope.row.status === '支付完成，待发货'">发货</el-button>   
                    <el-button @click="handleGoods(scope.row)" type="text" 
                    size="small" v-if="scope.row.status === '退货中'">确认收货</el-button>   
                    <el-button @click="handleAudit(scope.row)" type="text" 
                    size="small" v-if="scope.row.status === '退款申请'">退款审核</el-button>       
                    <el-button @click="handleLogistics(scope.row)" type="text" 
                    size="small" v-if="scope.row.status === '运输中' || scope.row.status === '已收货' || scope.row.status === '已完成'">物流</el-button>  
                    <el-button @click="lgsCancel(scope.row)" type="text" 
                    size="small" v-if="scope.row.status === '运输中'">取消寄件</el-button>              
                    <el-button @click="handleAddAddress" type="text" 
                    size="small" v-if="scope.row.status === '支付完成，待发货'">新增地址</el-button> 
                </template>
            </el-table-column>
            </el-table>
            <pagination
                style="text-align:right"
                v-show="total > 10"
                :total="total"
                :page.sync="queryParams.page"
                :limit.sync="queryParams.pagesize"
                @pagination="initData"
            />      
    </div>
    <delivery-dialog 
        :formData="deliveryForm"
        v-if="isShowDelivery"
        @close="closeDialog"
        @confirm="handleConfirmDelivery"/>
    <refund-dialog
        :formData="refundForm"
        v-if="isShowRefund"
        @close="closeDialog"
        @confirm="handleConfirm"/>

    <logistics-dialog    
        :formData="logisticsForm"
        :info="lgsData"
        v-if="isShowLogistics"
        @close="closeDialog"/>
    <add-address    
        :title="titleAddress"    
        v-if="isShowAddress"
        @close="closeDialog"
        @confirm="handleConfirmAddress"/>
<el-dialog
    title="收货信息"
    :visible.sync="showAddressDialog"
    width="30%"
    :before-close="handleClose">
    <div class="size16">收货姓名： {{ addressDetail.contactName }}</div>
    <div class="size16" style="margin: 20px 0;">收货电话： {{ addressDetail.contactPhone }}</div>
    <div class="size16" style="line-height: 30px;">
        收货地址：     
        {{ addressDetail.province }}{{ addressDetail.city }}{{ addressDetail.district }}
        {{ addressDetail.addressDes}}
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="showAddressDialog = false">关闭</el-button>
    </span>
</el-dialog>
<el-dialog
    title="取消寄件"
    :visible.sync="showCancelLgs"
    width="30%"
    :before-close="handleClose">
    <div class="size16">您确认取消寄件吗？</div>
    <div class="size16" style="margin: 20px 0;">
        <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入取消寄件原因"
            v-model="cancelMsg">
            </el-input>
    </div>   
    <span slot="footer" class="dialog-footer">
        <el-button @click="showCancelLgs = false">关闭</el-button>
        <el-button @click="confirmCancelLgs">确认</el-button>
    </span>
</el-dialog>
</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
import DeliveryDialog  from './components/deliveryDialog'
import RefundDialog  from './components/refundDialog'
import LogisticsDialog from './components/logisticsDialog.vue'
import AddAddress from './components/addAddress'
export default {
    components: {
        PageBack,
        pagination,
        DeliveryDialog,
        RefundDialog,
        LogisticsDialog,
        AddAddress
    },
    data() {
        return {
            isShowAddress: false,
            queryParams:{
                page: 1,
                pagesize: 10
            },
            searchForm:{
                username: '',
                phone: '',
                title: '',
                orderId: '',
                tradeId: '',
                certType: '',
                status: '',
            },
            tableData: [],
            statusOption: [
                {value: '100', label:'全部'},
                {value: '0', label:'已支付'},
                {value: '1', label:'待支付'},
                {value: '2', label: '取消订单'}, 
                {value: '3', label: '运输中'},          
                {value: '33', label: '退货中'},        
                {value: '4', label: '已收货'},
                {value: '5', label: '退款申请'}, 
                {value: '77', label: '退款中'},  
                {value: '8', label: '退款完成'},  
            ],
            total: 0,
            typeOption: [],
            isShowDelivery: false,
            isShowLogistics: false,
            deliveryTitle: '',
            deliveryForm: {},
            isShowRefund: false,
            refundForm: {},
            logisticsData: {},
            logisticsForm: {},
            orderType: [
                {value: '100', label: '全部'}, 
                {value: '0', label:'已支付'},
                {value: '3', label: '运输中'},  
                {value: '33', label: '退货中'},                
                {value: '4', label: '已收货'},
                {value: '5', label: '退款申请'},                 
                {value: '77', label: '退款中'},  
            ],
            activeName: '100',
            showAddressDialog: false,
            addressDetail: {},
            lgsID: '',
            lgsCompany: '',
            lgsData: [],
            lgsCompanyOption: [
                {value: 'jd',label: '京东物流'},
                {value: 'debangkuaidi',label: '德邦快递'},
                {value: 'shunfeng',label: '顺丰速运'},
                {value: 'zhongtong',label: '中通快递'},
                {value: 'shunfengkuaiyun',label: '顺丰快运'},
                {value: 'sxjdfreight',label: '顺心捷达'},
                {value: 'kuayue',label: '跨越速运'},
            ],
            cancelMsg: '暂时不寄件了',
            taskId: '',
            orderId: '',
            showCancelLgs:false,
            titleAddress: '',
        }
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
        roles(){
            return localStorage.getItem('roles')
        }, 
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }, 
    },
    created() {
        this.getType()
    },
    mounted() {
        this.initData()
    },
    methods: {
        getType(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 110,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.typeOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })
                }
            })
        },
        handleSwitchTab(tab, event){
            // console.log(tab.name)
            if(tab.name === '100'){
                this.searchForm.status =  ''
            }else{
                this.searchForm.status = tab.name    
            }
            setTimeout(()=>{
                this.initData()
            },100)            
        },
        initData(){
            let { username,phone,certType, title ,tradeId,orderId,status} = this.searchForm
            if(status==='100'){
                status = ''
            }
            let params = {
                opcode: this.$code.OrderQuery,
                i_client_no: '',
                v_name: username,
                v_phone: phone,
                v_goods_classify: certType,
                v_goods_title: title,
                i_goods_order: tradeId,
                i_no: orderId,
                c_status: status,
                start_date: '',
                end_date: '',
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let arr = res.Data.DataTable
                    this.total = res.Data.SumCount
                    if(arr.length > 0){
                        // console.log(arr)
                        this.tableData = arr.map(item=>{
                            let  mainImageUrl = item['封面主图']  

                            return{
                                index: item['序号'],
                                orderId: item['订单序号'],
                                tradeId: item['流水号'],
                                username: item['下单人'],
                                price: item['价格'],
                                tel: item['收货人电话'],
                                productName: item['商品标题'],
                                subName: item['商品副标题'],
                                productId: item['商品标识'],
                                quanlity: item['数量'],
                                postage: item['邮费'],
                                des: item['详情'],                              
                                dateFormat: this.$help.formatDate(item['下单日期']) +' '+ this.$help.formatTime(item['下单时间']),  
                                status: item['订单状态'],
                                statusValue: item['订单状态'],
                                deliverRules:item['发货规则'],
                                refundRules: item['退换货规则'],
                                imageTextUrl: item['图文详情'],
                                detailImageUrl: item['封面主图1'],
                                mainImageUrl: mainImageUrl,
                                contactName: item['收货人'],
                                contactPhone: item['收货人电话'],
                                province: item['收货省'],
                                city: item['收货市'],
                                district: item['收货县'],
                                addressDes: item['收货详细地址']                 
                            }
                        })
                    }else{
                        this.tableData = []
                    }
                }
            })
        },
        certTypeToText(value){
            let name = ''
            let arr  = this.typeOption.filter(i=>i.value === value)
            name= arr[0].label
            return name
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleAudit(row){
            this.isShowRefund = true
            this.refundForm = {
                orderId: row.orderId,
                tradeId: row.tradeId
            }
            // this.$confirm('确认审核？','警告').then(res=>{
            //     this.confirmAudit(obj)
            // })
        },
        confirmAudit(obj){
            // 1:同意；2：拒绝
            let params = {
                opcode: this.$code.RefundPayAduit,
                i_goods_order: obj.tradeId,
                order: obj.orderId,
                i_flag: 1,
                v_returnof_goods_not: '',
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('审核成功')
                    this.initData()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        handleDelivery(row){
            console.log('订单数据',row)
            this.isShowDelivery = true
            // this.deliveryForm = {
            //     orderId: row.orderId,
            //     tradeId: row.tradeId
            // }
            this.deliveryForm = {...row}
        },
        handleConfirmDelivery(row){
            console.log('发货数据',row)
        },
        // 物流发货
        handleConfirmDelivery(row){
            let {orderId,tradeId,productName} = this.deliveryForm
            let selectTimeArr = row.reserveTime.split('-')
            let params = {
                opcode: this.$code.GenerateLgsNumber,
                i_goods_order: tradeId,
                order: orderId,
                kuaidicom: row.logisticsName,
                sender_name: row.senderName,
                sender_mobile: row.senderPhone,
                sender_address: row.senderAddress,
                receiver_name: row.receiverName,
                receiver_mobile: row.receiverPhone,
                receiver_address: row.receiverAddress,
                weight: row.weight,            
                goods_name: productName,
                dayType: row.reserveDate,
                pickupStartTime: selectTimeArr[0],
                pickupEndTime: selectTimeArr[1],              
                remark: row.remark,
            }
            // console.log('请求接口的数据',params)
            
            this.$api.requestAPI(params).then(res=>{
                    if(res.IsSuccess){
                        this.$message.success(res.Message)
                        this.initData()
                        this.closeDialog()
                        this.$message.success('发货成功！')
                    }else{
                        this.$message.error(res.Message)
                    }
            })
        },
        closeDialog(){
            this.isShowDelivery = false
            this.isShowRefund = false
            this.isShowLogistics = false
            this.isShowAddress = false
        },
        handleConfirm(){
            this.initData()
        },
        getLogisticsQuery(row){
            let params = {
                opcode: this.$code.LogisticsQuery,
                i_goods_order: row.tradeId,
                i_no: row.orderId,
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    if(res.Data.SumCount > 0){
                        let list = res.Data.DataTable;
                        let result = list.map(item=>{
                            return{
                                index: item['订单序号'],
                                logisticsName: item['物流名称'],
                                logisticsNumber: item['物流订单号'],
                                logisticsId: item['订单流水号'],
                                status: item['物流状态'],
                                date: item['确认收货日期'],
                                time: item['确认收货时间'],
                                direction: item['方向'],
                            }
                        })
                        let lgs = result.filter(i => i.direction === '退货')
                        // let lgsDevliver = result.filter(i => i.direction === '发货')
                        this.logisticsData = lgs[0]
                    }
                }else{
                    this.logisticsData = {}
                }
            })
        },
        // 退货收货
        handleGoods(row){
            this.getLogisticsQuery(row)
            this.$confirm('','确定收到买家的退货吗？',).then(res=>{
               this.confirmGoods()
            }).catch(err=>{
                console.log(err)
            })
        },
        confirmGoods(){
            let params = {
                opcode: this.$code.RefundGoodsQuery,
                v_logistics_no: this.logisticsData.logisticsNumber
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('操作成功')
                    this.initData()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        searchQuery(){
            this.initData()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        lookAddress(row){
            this.showAddressDialog = true
            this.addressDetail = {...row}
        },
        handleClose(){
            this.showAddressDialog = false
            this.showCancelLgs = false
        },
        // 查看物流信息
        handleLogistics(row){
            // 物流查询  134          
            // this.logisticsForm = {
            //     orderId: row.orderId,
            //     tradeId: row.tradeId
            // }
            this.$message.success('数据加载中，请稍等...')
            this.deliveryLogisticsQuery(row)            
        },
        // 发货的物流信息
        deliveryLogisticsQuery(row){            
            let params = {
                opcode: this.$code.LogisticsQuery,
                i_goods_order: row.tradeId,
                i_no: row.orderId,
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    if(res.Data.SumCount > 0){
                        let list = res.Data.DataTable;
                        let result = list.map(item=>{
                            return{
                                index: item['订单序号'],
                                logisticsName: item['物流名称'],
                                logisticsNumber: item['物流订单号'],
                                logisticsId: item['订单流水号'],
                                status: item['物流状态'],
                                date: this.$help.formatDate(item['发货日期']),
                                time: this.$help.formatTime(item['发货时间']) ,
                                direction: item['方向'],
                                pollToken: item.pollToken,
                                taskId: item.taskId,
                                orderId: item.order_id,
                                phone: item['寄件人电话'],
                            }
                        })
                        let lgsDevliver = result.filter(i => i.direction === '发货')
                        console.log('物流单号查询',lgsDevliver)
                        // let lgsArr = []
                        // if(lgsDevliver.length > 1){
                        //     console.log('a')
                        //     lgsArr = lgsDevliver[lgsDevliver.length-1]
                        // }else{
                        //     console.log('b')
                        //     lgsArr = lgsDevliver[0]
                        // }
                        this.taskId  = lgsDevliver[0].taskId
                        this.orderId = lgsDevliver[0].orderId
                        setTimeout(()=>{
                            // this.lgsCancel(lgsDevliver[0])
                            this.deliveryLogisticsQueryNew(lgsDevliver[0])
                        },100)
                    }
                }else{
                    console.log(res)
                }
            })
        },
        //快递100物流查询
        deliveryLogisticsQueryNew(row){
            let params = {
                opcode: this.$code.LogisticsQueryNew,
                kuaidicom: row.logisticsName,
                kuaidinum: row.logisticsNumber,
                pollToken: row.pollToken,
                phone: row.phone,
            }
            this.$api.requestAPI(params).then(res=>{                
                if(res.IsSuccess){                  
                    const  result = res.Message
                    const lgsData = JSON.parse(result) 
                    console.log('aaa',lgsData)              
                    let companyArr =  this.lgsCompanyOption.filter((i)=> i.value === lgsData.com)
                    if(companyArr.length > 0){                      
                        this.logisticsForm = {
                            logisticsName: companyArr[0].label,
                            logisticsNumber: lgsData.nu
                        }
                        this.lgsID  = lgsData.nu   
                        this.lgsCompany = companyArr[0].label
                        this.lgsData = lgsData.data
                        this.isShowLogistics = true
                    }else{
                        this.lgsID = '',
                        this.lgsCompany = ''
                        this.lgsData=  []
                        this.logisticsForm = {
                            logisticsName: '',
                            logisticsNumber: ''
                        }
                        this.isShowLogistics = false
                        this.$message.error('暂无物流信息，请稍后再查！')
                    }   
                    // console.log(lgsData.nu);
                    // console.log('物流数据',this.lgsData)                   
                }else{
                    this.isShowLogistics = false
                    this.$message.error('暂无物流信息，请稍后再查！')
                }
            })
        },
        lgsCancel(row){
            this.deliveryLogisticsQuery(row)
            this.showCancelLgs =  true
        },
        confirmCancelLgs(){
            if(this.cancelMsg === ''){
                this.$message.error('请输入取消寄件的原因！')
                return false
            }
            let params = {
                opcode: this.$code.LogisticsCancel,
                taskId: this.taskId,
                orderId: this.orderId,
                cancelMsg: this.cancelMsg,
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    // console.log('取消寄件',res.Message)
                    this.$message.success('取消成功')
                    this.initData()
                    this.showCancelLgs = false
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        handleAddAddress(){
            this.isShowAddress = true
            this.titleAddress = '新增发货地址'
        },
        handleConfirmAddress(){
            this.initData()
            this.closeDialog()
        },
    },
    destroyed() {
        this.searchForm.status = ''
    },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.address{
    text-decoration: underline;
    color: red;
}
</style>


// WEBPACK FOOTER //
// src/views/product/orderQuery.vue